import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import LavorisService from "../../services/LavorisService";
import { RootState } from "../../store/combineReducer";
import InfiniteTable from "../../components/others/InfiniteTableComponent/IntiniteTableComponent";
import { CompanyActionsResponse } from "../../services/Company/Company.type";

const getMovementEmail = (row: CompanyActionsResponse): string => {
  if (row.action === "SOLICITADO") {
    return row.solicitud_email || "---";
  }
  return row.email || "---";
};

const formatMovementAction = (action: string | null): string => {
  if (!action) return "---";
  if (action === "EDITADO-APROBADO") return "APROBADO";
  return action;
};

const movementsColumns = [
  {
    key: "name",
    title: "Nombre",
    className: "col-name",
    render: (_value: unknown, row: CompanyActionsResponse) =>
      row?.name || "---",
  },
  {
    key: "email",
    title: "Email",
    className: "col-email",
    render: (_value: unknown, row: CompanyActionsResponse) =>
      getMovementEmail(row),
  },
  {
    key: "action",
    title: "Acción",
    className: "col-action",
    render: (value: string | null) => formatMovementAction(value),
  },
  {
    key: "date",
    title: "Fecha",
    className: "col-date",
    render: (_value: unknown, row: CompanyActionsResponse) =>
      row?.date ? moment(row.date).format("DD/MM/YY HH:mm") : "---",
  },
];

const MovementsTab = () => {
  const LavorisInstance = LavorisService.getInstance();
  const { currentCompany, companies } = useSelector(
    (state: RootState) => state.user,
  );
  const companyId = currentCompany?.id ?? companies?.[0]?.id;
  const [movements, setMovements] = useState<CompanyActionsResponse[]>([]);
  const [tableLoading, setTableLoading] = useState(true);

  useEffect(() => {
    if (!companyId) {
      setTableLoading(false);
      return;
    }

    let cancelled = false;

    const getMovements = async () => {
      setTableLoading(true);
      try {
        const response =
          await LavorisInstance.CompanyServices.getCompanySpecificActions(
            companyId,
          );
        if (!cancelled) {
          setMovements(Array.isArray(response) ? response : []);
        }
      } catch (error) {
        console.error(error);
        if (!cancelled) {
          setMovements([]);
        }
      } finally {
        if (!cancelled) {
          setTableLoading(false);
        }
      }
    };

    getMovements();

    return () => {
      cancelled = true;
    };
  }, [companyId, LavorisInstance]);

  return (
    <div className="gestiones-tab-content">
      <InfiniteTable
        data={movements}
        columns={movementsColumns}
        loading={tableLoading}
        hasMore={false}
        onLoadMore={() => {}}
        emptyMessage="Momentáneamente no hay datos para mostrar"
        loadingMessage={
          movements.length === 0 ? "Cargando datos..." : "Buscando más datos..."
        }
        striped
        hover
        bordered
      />
    </div>
  );
};

export default MovementsTab;
